const addComma = (previousString) => {
  if (previousString !== "") {
    return ", "
  } else {
    return ""
  }
}

const Venues = props => {
  let venuesElements = [];
  if (props.venues !== undefined && props.venues.length > 0) {
    venuesElements = props.venues.map((venue, index) => {
      if (props.venueids.includes(venue.venueId)) {
        return <div className="venue-detail" key={index}>
          {venue.name}<br />
          {venue.address}{addComma(venue.address)}
          {venue.county}{addComma(venue.county)}
          {venue.postcode}
        </div>
      } else {
        return null
      }
    }).filter(i => !!i);
    return (venuesElements);
  } else {
    return (null);
  }
}

export default Venues;
